import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Heading, Kicker, Lead } from './ui';
import { IMAGES, trustPoints } from '../../data/vcars';
export function TrustSection() {
  return <section className="relative overflow-hidden" data-id="element-112" data-mp="1xn6e8x7pqjim">
      <img src={IMAGES.advisor} alt="Asesor de VCARS atendiendo a un cliente" className="absolute inset-0 h-full w-full object-cover" data-id="element-113" data-mp="1xllkh9t834lt" />
      <div className="absolute inset-0 bg-[#08090b]/90" data-id="element-114" data-mp="26fzw92ejnx06" />

      <div className="relative mx-auto grid w-full max-w-6xl gap-10 px-5 py-14 sm:px-8 sm:py-20 lg:grid-cols-2 lg:gap-16 lg:px-12 lg:py-28" data-id="element-115" data-mp="26hkpmop4h9wg">
        <div data-id="element-116" data-mp="2gefppc11nicu">
          <Kicker data-id="element-117" data-mp="2gepgh1twxtjl">Confianza</Kicker>
          <Heading className="mt-4 text-white" data-id="element-118" data-mp="2gbjrrnp74toe">
            Comprá con más claridad y menos dudas
          </Heading>
          <Lead className="mt-4 text-white/60" data-id="element-119" data-mp="lzmuhe42otlf">
            Nuestro objetivo no es venderte cualquier auto. Es ayudarte a
            encontrar una opción que realmente te sirva.
          </Lead>
          <div className="mt-8 bg-[#3b6bff] p-6 sm:p-7" data-id="element-120" data-mp="3fzak3l8f4dpa">
            <p className="text-lg font-semibold leading-snug text-white sm:text-xl" data-id="element-121" data-mp="3g0vffd2k40o7">
              En VCARS te acompañamos desde la primera consulta hasta el próximo
              paso de compra.
            </p>
          </div>
        </div>

        <ul className="lg:pt-6" data-id="element-122" data-mp="31ao3lg721fwh">
          {trustPoints.map(point => <li key={point} className="flex items-center gap-3 border-b border-white/10 py-3.5" data-id="element-123" data-mp="318bemj2vq59x">
              <CheckIcon className="h-5 w-5 shrink-0 text-[#5b83ff]" strokeWidth={3} data-id="element-124" data-mp="3tyk0akwmj7t9" />
              <span className="text-base text-white/85 sm:text-lg" data-id="element-125" data-mp="3oye0uik44h0m">
                {point}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}